export const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

export const getContactFieldRules = (locale) => {
  const baseLocale = String(locale || "en")
    .toLowerCase()
    .split(/[-_]/)[0];
  const isJapanese = baseLocale === "ja" || baseLocale === "jp";

  return isJapanese
    ? {
        postalMaxLength: 7,
        phoneMaxLength: 11,
        isValidPostal: (value) => /^\d{7}$/.test(value),
        isValidPhone: (value) => /^\d{10,11}$/.test(value),
      }
    : {
        postalMaxLength: 5,
        phoneMaxLength: 10,
        isValidPostal: (value) => /^\d{5}$/.test(value),
        isValidPhone: (value) => /^\d{10}$/.test(value),
      };
};

export const sanitizeContactValue = (value, maxLength) =>
  digitsOnly(value).slice(0, maxLength);
